import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './lib/auth';
import { ErrorBoundary } from './components/ErrorBoundary';
import BoardList from './pages/BoardList';
import BoardDetail from './pages/BoardDetail';
import PublicBoard from './pages/PublicBoard';
import ActivityPage from './pages/Activity';
import SettingsPage from './pages/Settings';
import SetupPage from './pages/Setup';
import LoginPage from './pages/Login';
import Layout from './components/Layout';
import './App.css';

function AuthGate({ children }) {
  const { user, loading, setupComplete } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-muted-foreground text-sm">Loading...</div>
      </div>
    );
  }

  if (setupComplete === false) return <SetupPage />;
  if (!user) return <LoginPage />;

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public route — no auth */}
      <Route path="/p/:token" element={<PublicBoard />} />

      {/* Auth-gated routes */}
      <Route
        element={
          <AuthGate>
            <Layout />
          </AuthGate>
        }
      >
        <Route path="/" element={<Navigate to="/boards" replace />} />
        <Route path="/boards" element={<BoardList />} />
        <Route path="/boards/:boardId" element={<BoardDetail />} />
        <Route path="/boards/:boardId/activity" element={<ActivityPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="bottom-right" richColors />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
